/**
 * Panel lateral del carrito: responsive, scroll y badge flotante.
 */

function setCartOpenState(win, $, open) {
	const $panel = $('.lateral-panel');
	const $backdrop = $('#poskn-cart-backdrop');
	$panel.toggleClass('active', !!open);
	$backdrop.toggleClass('active', !!open).attr('aria-hidden', open ? 'false' : 'true');
	$('body').toggleClass('poskn-cart-open', !!open);
}

function initCartPanelEvents(win, $) {
	if (win._posknCartPanelBound) return;
	win._posknCartPanelBound = true;

	$(() => {
		win.initializeResponsive();

		$('.lateral-panel').on('scroll', () => {
			win.toggleScrollButton();
		});

		win.setTimeout(() => {
			if (typeof win.checkCarritoScroll === 'function') win.checkCarritoScroll();
		}, 300);
	});
}

export function attachCartPanelGlobals(win, $) {
	initCartPanelEvents(win, $);

	win.updateCartToggleButton = function updateCartToggleButton() {
		const carrito = win.carrito || [];
		const totalItems = carrito.reduce((sum, item) => sum + (parseFloat(item.cantidad) || 0), 0);
		const badgeText =
			Math.abs(totalItems - Math.round(totalItems)) < 0.001
				? String(Math.round(totalItems))
				: totalItems.toFixed(2);
		$('#cart-badge').text(badgeText);
		if (totalItems > 0) {
			$('#cart-badge').show();
		} else {
			$('#cart-badge').hide();
		}
	};

	win.handleResponsiveLayout = function handleResponsiveLayout() {
		const width = win.innerWidth;
		if (width <= 768) {
			$('.cart-toggle-btn').addClass('show');
			setCartOpenState(win, $, false);
		} else {
			$('.cart-toggle-btn').removeClass('show');
			setCartOpenState(win, $, false);
			$('.lateral-panel').removeAttr('style');
		}
	};

	win.toggleCartPanel = function toggleCartPanel() {
		const open = !$('.lateral-panel').hasClass('active');
		setCartOpenState(win, $, open);
	};

	win.closeCartPanel = function closeCartPanel() {
		setCartOpenState(win, $, false);
	};

	win.openCartPanel = function openCartPanel() {
		if (win.innerWidth <= 768) {
			setCartOpenState(win, $, true);
		}
	};

	win.initializeResponsive = function initializeResponsive() {
		win.updateCartToggleButton();
		win.handleResponsiveLayout();

		$('#cart-toggle-btn')
			.off('click.posknCart')
			.on('click.posknCart', (e) => {
				e.preventDefault();
				e.stopPropagation();
				win.toggleCartPanel();
			});

		$('#poskn-cart-backdrop, #poskn-sheet-close')
			.off('click.posknCart')
			.on('click.posknCart', (e) => {
				e.preventDefault();
				e.stopPropagation();
				win.closeCartPanel();
			});

		$(document)
			.off('keydown.posknCart')
			.on('keydown.posknCart', (e) => {
				if (e.key === 'Escape' && win.innerWidth <= 768) {
					win.closeCartPanel();
				}
			});

		$(win)
			.off('resize.posknCart orientationchange.posknCart')
			.on('resize.posknCart orientationchange.posknCart', () => {
				win.handleResponsiveLayout();
				win.updateCartToggleButton();
			});
	};

	win.scrollToTop = function scrollToTop() {
		const lateralPanel = document.querySelector('.lateral-panel');
		if (lateralPanel) {
			lateralPanel.scrollTo({ top: 0, behavior: 'smooth' });
		}
	};

	win.toggleScrollButton = function toggleScrollButton() {
		const lateralPanel = document.querySelector('.lateral-panel');
		const scrollButton = document.getElementById('scrollToTop');
		if (lateralPanel && scrollButton) {
			if (lateralPanel.scrollTop > 100) {
				scrollButton.classList.add('show');
			} else {
				scrollButton.classList.remove('show');
			}
		}
	};

	win.checkCarritoScroll = function checkCarritoScroll() {
		const carritoContainer = document.querySelector('.carrito-container');
		if (carritoContainer) {
			if (carritoContainer.scrollHeight > carritoContainer.clientHeight) {
				carritoContainer.classList.add('scrollable');
			} else {
				carritoContainer.classList.remove('scrollable');
			}
		}
	};
}
